import React, { useCallback } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { removeSelected } from '~data/actions/bookmarks'

import { Confirm } from '~co/overlay/dialog'
import { Button, Icon } from '~ui'

export default function BookmarksHeaderSelectModeRemove({ selectMode = {} }) {
    const dispatch = useDispatch()
    const { spaceId, all, ids = [] } = selectMode

    const onRemoveClick = useCallback(
        e => {
            e.preventDefault()

            Confirm(t.s('areYouSure'), { variant: 'warning' }).then(yes => {
                if (!yes) return
                dispatch(removeSelected(spaceId))
            })
        },
        [dispatch, spaceId]
    )

    return (
        <Button
            variant='outline'
            title={t.s('remove')}
            disabled={!all && !ids.length}
            onClick={onRemoveClick}>
            <Icon name='trash' />

            <span className='hide-on-small-body'>
                {t.s('remove')}
            </span>
        </Button>
    )
}
